import Cookies from 'js-cookie'

import {
  SHOPIFY_CART_ID_COOKIE,
  SHOPIFY_CART_URL_COOKIE,
  SHOPIFY_COOKIE_EXPIRE,
} from '../const'

import cartCreateMutation from './mutations/cart-create'
import { getCustomerToken } from './customer-token'
// import { CartCreatePayload } from '../schema'

export const cartCreate = async (
  fetch: any,
  createSeparateCart?: boolean,
  customer?: any
): Promise<any> => {  // ToDo: Typing

  const customerAccessToken = getCustomerToken()

  const input: any = {};

  if (customerAccessToken != null || customer != null) {
    input.buyerIdentity = {};
  }
  if (customerAccessToken != null) {
    input.buyerIdentity.customerAccessToken = customerAccessToken;
  }
  if (customer != null) {
    input.buyerIdentity.email = customer.email;
  }

  const data = await fetch({
    query: cartCreateMutation,
    variables: {
      input
    }
  })

  const cart = data.cartCreate?.cart
  const cartId = cart?.id

  if (cartId && createSeparateCart !== true) {
    const options = {
      expires: SHOPIFY_COOKIE_EXPIRE,
    }
    Cookies.set(SHOPIFY_CART_ID_COOKIE, cartId, options)
    Cookies.set(SHOPIFY_CART_URL_COOKIE, cart.checkoutUrl, options)
  }

  return cart
}

export default cartCreate
